// Dependencies
import React from "react";

// Material UI components
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import CardContent from "@mui/material/CardContent";
import Card from "@mui/material/Card";
import Skeleton from "@mui/material/Skeleton";

// Styles
import DrawerHandle from "features/main/components/DrawerHandle/DrawerHandle.component";
import { useStyles } from "./VehicleCardMobile.styles";

const VehicleCardMobileSkeleton = () => {
  const classes = useStyles();

  return (
    <Grid item xs={12} data-aos="fade-up">
      <Card className={classes.root}>
        <DrawerHandle />
        <div className={classes.details}>
          <CardContent className={classes.mainContent}>
            <Skeleton>
              <Typography className={classes.title} variant="subtitle1">
                2020 Example Vehicle
              </Typography>
            </Skeleton>
            <div className="flexGrow" />
            <Skeleton>
              <Typography variant="subtitle2">$30,000</Typography>
            </Skeleton>
          </CardContent>
          <Skeleton>
            <Typography variant="subtitle2" color="textSecondary">
              Vancouver
            </Typography>
          </Skeleton>
          <div className="flexGrow" />
          <div className={classes.bottomContent}>
            <Skeleton>
              <Typography variant="subtitle2">$30,000</Typography>
            </Skeleton>
            <div className="flexGrow" />
            <Skeleton>
              <Typography variant="subtitle2">1/100</Typography>
            </Skeleton>
          </div>
        </div>
        <div className={classes.imageContainer}>
          <Skeleton variant="rectangular" width={400} height="50vw" />
        </div>
      </Card>
    </Grid>
  );
};

export default VehicleCardMobileSkeleton;
